var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeforeArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.379826 0.549748C0.672719 0.256855 1.14759 0.256855 1.44049 0.549748L7.96049 7.06975C9.02338 8.13264 9.02338 9.86751 7.96049 10.9304L1.44049 17.4504C1.14759 17.7433 0.672719 17.7433 0.379826 17.4504C0.0869329 17.1575 0.0869329 16.6826 0.379826 16.3897L6.89983 9.86975C7.37693 9.39264 7.37693 8.60752 6.89983 8.13041L0.379826 1.61041C0.0869329 1.31752 0.0869329 0.842641 0.379826 0.549748Z",
    fill: "#80899C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeArrowNext);
export default __webpack_public_path__ + "static/media/beforeArrowNext.80532b43275bcf53c31facba897496cd.svg";
export { ForwardRef as ReactComponent };